import * as React from 'react';
import { IconProductSpecialLoanRate24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BankIcon.css';
import { IPromoBank } from '../../types/newbuilding/promoInfo';

interface IBankIconProps {
  bank?: IPromoBank | null;
}

export function BankIcon({ bank }: IBankIconProps): React.JSX.Element {
  if (bank && (bank.logoUrl || bank.secondSquareImageUrl)) {
    return (
      <div
        className={styles['logo']}
        style={{ backgroundImage: `url(${bank.secondSquareImageUrl || bank.logoUrl})` }}
      />
    );
  }

  return (
    <div className={styles['icon']}>
      <IconProductSpecialLoanRate24 />
    </div>
  );
}
